import { render, staticRenderFns } from "./PatientTimeline.vue?vue&type=template&id=3c36cb08&scoped=true&"
import script from "./PatientTimeline.vue?vue&type=script&lang=js&"
export * from "./PatientTimeline.vue?vue&type=script&lang=js&"
import style0 from "./PatientTimeline.vue?vue&type=style&index=0&id=3c36cb08&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c36cb08",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VCard,VCardText,VCardTitle,VTimeline,VTimelineItem})
